import i from './page-header-admin.container';

export default i;
